<template>
  <div>
    <mobile-course v-if="isH5" />
    <pc-course v-else />
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import PcCourse from "./PcCourse.vue";
import mobileCourse from "./MobileCourse.vue";
export default {
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  components: {
    "pc-course": PcCourse,
    "mobile-course": mobileCourse,
  },
};
</script>

<style lang="scss" scoped></style>
